class ShadeVisualiser extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 300)

    this.updateCarouselButtons = this.updateCarouselButtons.bind(this)
  }

  setupListeners() {
    super.setupListeners()

    this.setupCategoryFilters()
    this.setupShadeFilters()
    this.setupProductFormButtons()

    this.els['view-switcher']?.elements?.forEach(switcher =>
      switcher.addEventListener('change', (e) => {
        this.viewSwitcherChanged.bind(this)(e)
      }))

    if (this.els['clear-shade']) {
      this.els['clear-shade'].element.addEventListener('click', this.shadeClearClick.bind(this))
    }
  }

  setupProductFormButtons() {
    const productFormVariants = this.externalEls.productFormVariant?.elements

    if (!productFormVariants || productFormVariants.length === 0) return

    productFormVariants.forEach(button => {
      button.addEventListener('click', (e) => {
        const shadeId = button.dataset.variantId

        this.els['shade-swatch']?.elements.forEach(btn => {
          if (btn.dataset.variantId === shadeId) {
            this.shadeSwatchClick(btn)
          }
        })
      })
    })
  }

  setupCategoryFilters() {
    const categoryButtons = this.els?.category?.elements
    if (!categoryButtons || categoryButtons.length === 0) return

    categoryButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const activeShade = this.querySelector('[data-active-shade]')?.dataset.variantId

        if (button.classList.contains('sec-ShadeVisualiser_CategoryFilter-active')) {
          button.classList.remove('sec-ShadeVisualiser_CategoryFilter-active')
          button.removeAttribute('data-active-category')

          this.els.slide.elements.forEach(slide => {
            if (slide.dataset.swatchId == activeShade || activeShade == undefined) {
              slide.setAttribute('aria-hidden', false)
            }
          })
        } else {
          const category = button.dataset.category
          this.filterSlides(category, activeShade)

          categoryButtons.forEach(btn => {
            btn.classList.remove('sec-ShadeVisualiser_CategoryFilter-active')
            btn.removeAttribute('data-active-category')
          })

          button.classList.add('sec-ShadeVisualiser_CategoryFilter-active')
          button.setAttribute('data-active-category', true)
        }

        this.updateCarouselButtons()
      })
    })
  }

  setupShadeFilters() {
    const shadeButtons = this.els['shade-swatch']?.elements
    if (!shadeButtons || shadeButtons.length === 0) return

    shadeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()

        const productFormVariantButtons = this.externalEls.productFormVariant.elements
        const shadeId = button.dataset.variantId

        productFormVariantButtons.forEach(btn => {
          if (btn.dataset.variantId === shadeId) {
            btn.click()
          }
        })
        this.updateCarouselButtons()
      })
    })
  }

  shadeClearClick() {
    const activeCategory = this.querySelector('[data-active-category]')?.dataset.category
    const selectedShade = this.els['selected-shade'].element

    this.els['shade-swatch']?.elements.forEach((button) => {
      button.classList.remove('sec-ShadeVisualiser_ShadeFilter-active')
      button.removeAttribute('data-active-shade')
    })

    this.els.slide.elements.forEach((slide) => {
      if (slide.dataset.category === activeCategory || activeCategory === undefined) {
        slide.setAttribute('aria-hidden', false)
      }
    })

    selectedShade.innerText = selectedShade.dataset.noShade
    selectedShade.classList.add('sec-ShadeVisualiser_SelectedShade-noSelectedShade')

    this.updateCarouselButtons()
  }

  shadeSwatchClick(button) {
    const shadeButtons = this.els['shade-swatch']?.elements
    const activeCategory = this.querySelector('[data-active-category]')?.dataset.category
    const selectedShade = this.els['selected-shade'].element

    if (!shadeButtons || shadeButtons.length === 0) return

    if (button.classList.contains('sec-ShadeVisualiser_ShadeFilter-active')) {
      button.classList.remove('sec-ShadeVisualiser_ShadeFilter-active')
      button.removeAttribute('data-active-shade')

      this.els.slide.elements.forEach(slide => {
        if (slide.dataset.category == activeCategory || activeCategory == undefined) {
          slide.setAttribute('aria-hidden', false)
        }
      })

      selectedShade.innerText = selectedShade.dataset.noShade
      selectedShade.classList.add('sec-ShadeVisualiser_SelectedShade-noSelectedShade')

      this.updateCarouselButtons()
    } else {
      const shadeId = button.dataset.variantId
      this.filterSlides(activeCategory, shadeId)

      shadeButtons.forEach(btn => {
        btn.classList.remove('sec-ShadeVisualiser_ShadeFilter-active')
        btn.removeAttribute('data-active-shade')
      })
      button.classList.add('sec-ShadeVisualiser_ShadeFilter-active')
      button.setAttribute('data-active-shade', true)

      selectedShade.innerText = button.dataset.variantTitle
      selectedShade.classList.remove('sec-ShadeVisualiser_SelectedShade-noSelectedShade')
    }
  }

  filterSlides(category, shadeId) {
    this.els.slide.elements.forEach(slide => {
      const slideCategory = slide.dataset.category

      if ((category == undefined || slideCategory.includes(category)) && (shadeId == undefined || slide.dataset.swatchId == shadeId)) {
        slide.setAttribute('aria-hidden', false)
      } else {
        slide.setAttribute('aria-hidden', true)
      }
    })
  }

  viewSwitcherChanged(e) {
    const toggleState = e.target.checked
    const currentView = this.els.slides?.element?.dataset?.view

    if (currentView == 'model') {
      this.els.slides.element.dataset.view = 'swatch'
    } else {
      this.els.slides.element.dataset.view = 'model'
    }

    this.els['view-switcher-input'].elements.forEach(input => {
      input.checked = toggleState
    })

    this.els['view-label'].elements.forEach(label => {
      label.setAttribute('aria-selected', toggleState)
    })
  }

  updateCarouselButtons() {
    const slides = Array.from(this.els.slide.elements).filter(slide => slide.getAttribute('aria-hidden') !== 'true')
    if (slides.length < 5) {
      this.els.next.element.style.display = 'none'
      this.els.previous.element.style.display = 'none'
    } else {
      this.els.next.element.style.display = 'block'
      this.els.previous.element.style.display = 'block'
    }

    this.carousel.destroy()
    this.carousel = null
    this.carousel = this.setupCarousel()
  }

  setupCarousel() {
    if (!this.els.slide) return

    this.els.slides.element.classList.add('keen-slider')
    this.els.slides.elements.forEach(el => el.classList.add('keen-slider__slide'))

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.25,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 700px)': {
            slides: {
              perView: 2.7,
              spacing: 2,
            },
          },
          '(min-width: 1000px)': {
            slides: {
              perView: 4.3,
              spacing: 2,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shade-visualiser')) {
  customElements.define('shade-visualiser', ShadeVisualiser)
}
